document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('.cbs-upload input[type=file]').forEach(i=>i.addEventListener('change',()=>{const s=i.parentElement.querySelector('[data-file]');if(s&&i.files[0])s.textContent=i.files[0].name}))
document.querySelectorAll('[data-cbs-tier-card]').forEach(card=>{
  const img=card.querySelector('[data-cbs-tier-img]'),prefixEl=card.querySelector('[data-cbs-tier-prefix]'),numEl=card.querySelector('[data-cbs-tier-num]'),servesEl=card.querySelector('[data-cbs-tier-serves]')
  const fadeTargets=[img,prefixEl,numEl,servesEl].filter(Boolean)
  card.querySelectorAll('.cbs-tier-toggle button').forEach(btn=>{
    btn.addEventListener('click',()=>{
      if(btn.classList.contains('is-active'))return
      const tier=btn.dataset.tier
      card.querySelectorAll('.cbs-tier-toggle button').forEach(b=>{const active=b===btn;b.classList.toggle('is-active',active);b.setAttribute('aria-pressed',String(active))})
      fadeTargets.forEach(el=>el.classList.add('cbs-fade-out'))
      setTimeout(()=>{
        if(img)img.src=card.dataset['img'+tier]
        if(prefixEl)prefixEl.textContent=card.dataset['pricePrefix'+tier]
        if(numEl)numEl.textContent=card.dataset['priceNum'+tier]
        if(servesEl)servesEl.textContent=card.dataset['serves'+tier]
        fadeTargets.forEach(el=>el.classList.remove('cbs-fade-out'))
      },180)
    })
  })
})
const wireCbsCarousel=(gridSel,cardSel,dotsAttr)=>{document.querySelectorAll(gridSel).forEach(grid=>{const dotsWrap=grid.parentElement.querySelector('['+dotsAttr+']');if(!dotsWrap)return;const dots=dotsWrap.querySelectorAll('span');const cards=grid.querySelectorAll(cardSel);const sync=()=>{const gridMid=grid.getBoundingClientRect().left+grid.clientWidth/2;let idx=0,min=Infinity;cards.forEach((c,i)=>{const r=c.getBoundingClientRect();const d=Math.abs((r.left+r.right)/2-gridMid);if(d<min){min=d;idx=i}});dots.forEach((d,i)=>d.classList.toggle('is-active',i===idx))};let t;grid.addEventListener('scroll',()=>{clearTimeout(t);t=setTimeout(sync,60)},{passive:true});sync()})}
wireCbsCarousel('.cbs-price-grid','.cbs-price-card','data-cbs-pricing-dots')
wireCbsCarousel('.cbs-process-grid','.cbs-step','data-cbs-process-dots')});

// Wires the Custom Cake Order Form to submit to the Custom Cake App's
// inquiry API instead of Shopify's native contact-form handler. This is
// INQUIRY ONLY — it never creates an order or takes payment, it just files
// the request so Shannon can review and quote it in the app.
document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.getElementById('custom-cake-form');
  var formEl = document.getElementById('CbsCustomCakeForm');
  if (!wrapper || !formEl) return;

  var endpoint = wrapper.getAttribute('data-cbs-inquiry-endpoint');
  if (!endpoint) return; // not configured yet — let the native contact form submit instead

  var messageEl = formEl.querySelector('[data-cbs-form-message]');
  var submitBtn = formEl.querySelector('.cbs-submit');
  var submitDefaultText = submitBtn ? submitBtn.textContent : '';

  function setMessage(text, kind) {
    if (!messageEl) return;
    messageEl.textContent = text || '';
    messageEl.classList.remove('is-success', 'is-error');
    if (kind) messageEl.classList.add(kind);
  }

  formEl.addEventListener('submit', function (e) {
    e.preventDefault();
    setMessage('', null);
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting…';
    }

    var formData = new FormData(formEl);

    fetch(endpoint, { method: 'POST', body: formData })
      .then(function (res) {
        return res.json().catch(function () { return null; }).then(function (body) {
          if (!res.ok || !body || !body.ok) {
            var msg = (body && body.error) || 'Something went wrong submitting your request. Please try again.';
            throw new Error(msg);
          }
          return body;
        });
      })
      .then(function (body) {
        setMessage(
          'Thank you! Your request (' + body.requestNumber + ') has been received. We will review it and get back to you soon.',
          'is-success'
        );
        formEl.reset();
        var fileNameEl = formEl.querySelector('.cbs-upload [data-file]');
        if (fileNameEl) fileNameEl.textContent = 'JPG, PNG up to 10MB';
      })
      .catch(function (err) {
        setMessage(err && err.message ? err.message : 'Something went wrong submitting your request. Please try again.', 'is-error');
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitDefaultText;
        }
      });
  });
});